import { clockConstants } from '../constants/clock.constants';
import clockService from '../services/clock.service';
import { alertActions } from './alert.actions';
import { b64toBlob } from '../helpers/base64';

export const clockActions = {
  fetch,
  reprocess,
  create
};

function reprocess(id) {
  return async dispatch => {
    dispatch(request());

    try {
      const clockReprocess = await clockService.reprocess(id);    
         
      dispatch(success(clockReprocess));
      dispatch(alertActions.success('Registro reprocessado'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: clockConstants.FETCH_REQUEST } }
  function success(clockReprocess) { return { type: clockConstants.FETCH_SUCCESS, clockReprocess } }
  function failure(error) { return { type: clockConstants.FETCH_FAILURE, error } }
}

function create(payload) {
  return async dispatch => {
    dispatch(request());

    try {
      const clockReprocess = await clockService.create(payload);             
      dispatch(success(clockReprocess));
      dispatch(alertActions.success('Registro criado'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: clockConstants.FETCH_REQUEST } }
  function success(clockReprocess) { return { type: clockConstants.FETCH_SUCCESS, clockReprocess } }
  function failure(error) { return { type: clockConstants.FETCH_FAILURE, error } }
}

function fetch(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const clockRegisters = await clockService.fetch(params);    
      
      if (params.export && clockRegisters.file) {        
        const blob = b64toBlob(clockRegisters.file, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'registros-ponto.xlsx');
        tempLink.click();
      }
      
      dispatch(success(clockRegisters));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: clockConstants.FETCH_REQUEST } }
  function success(clockRegisters) { return { type: clockConstants.FETCH_SUCCESS, clockRegisters } }
  function failure(error) { return { type: clockConstants.FETCH_FAILURE, error } }
}

